import clsx from 'clsx'
import { getFontClasses } from '../utils/fonts'
import { FontSize } from '../common-types'

type TitleProps = {
  children?: string
  headingType?: HTMLTags
  className?: string
  fontSize?: FontSize
} & Record<string, unknown>

export type HTMLTags = 'h3' | 'h2' | 'h1' | 'p'

export default function Title({
  children,
  headingType = 'h2',
  className,
  fontSize,
  ...commonProps
}: TitleProps) {
  if (!children) {
    return null
  }

  if (headingType === 'p') {
    return (
      <p {...commonProps} className={clsx(className, getFontClasses(fontSize))}>
        {children}
      </p>
    )
  }

  if (headingType === 'h1') {
    return (
      <h1
        {...commonProps}
        className={clsx(className, getFontClasses(fontSize))}
      >
        {children}
      </h1>
    )
  }

  if (headingType === 'h3') {
    return (
      <h3
        {...commonProps}
        className={clsx(className, getFontClasses(fontSize))}
      >
        {children}
      </h3>
    )
  }

  return (
    <h2 {...commonProps} className={clsx(className, getFontClasses(fontSize))}>
      {children}
    </h2>
  )
}
